import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function OrderLimitCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Aikaraja asetettu</h2>
    </div>
  )
}

function AddTimedOrderLimit(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    timeLimit: '',
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer

  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    const dataToServer = {
      ...userData,
      timeLimit: Number(userData.timeLimit),
    }
    try {
      await axios.post(`${SERVER_URI}/set_timed_order_limit/`, dataToServer, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'ADD_TIMED_ORDER_LIMIT',
        data: { newLimit: dataToServer },
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in adding driver', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Aseta minimi aikaraja </h2>
              <form className='timeLimit_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='timeLimit'>
                  Aika tunteina:
                </label>
                <input
                  type='number'
                  id='timeLimit'
                  name='timeLimit'
                  onChange={onChange}
                  placeholder='Aika'
                  min='1'
                  max='5000000000'
                  required
                ></input>{' '}
                h<span className='validity'></span>{' '}
                <br className='desktop-break' />
                <input
                  type='submit'
                  id='gradient_Button'
                  value='Aseta aikaraja'
                />
              </form>
            </div>
          )}
          {show && <OrderLimitCreatedMessage handleClose={props.handleClose} />}
        </div>
      </div>
    </div>
  )
}

function TimedOrderLimit(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  //let storage = window.localStorage;
  //let userToken = storage.getItem("admin_token")

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddTimedOrderLimit
          dispatch={props.dispatch}
          handleClose={togglePopUp}
        />
      )}
      <h3>
        Voimassa oleva minimi <br />
        aikaraja aikatilauksille
      </h3>
      <div className='rides'>
        {props.timedOrderLimit === undefined ? (
          <LoginRequest />
        ) : props.timedOrderLimit.length === 0 ? (
          <h4>Ei aikarajaa</h4>
        ) : (
          <div className='customer_list'>
            Aikaraja: {props.timedOrderLimit.timeLimit} h<br />
          </div>
        )}
      </div>
      <button id='gradient_Button' onClick={togglePopUp}>
        Aseta minimi aikaraja aikatilauksille
      </button>
    </div>
  )
}

export default TimedOrderLimit
